export default async function (lang: string, locale: Ref<string>) {
  const augmentoLanguage = useCookie('Augmento-locale', { domain: useCookiesDomain() })
  augmentoLanguage.value = lang
  locale.value = lang

  // Only set the HTML lang attribute on the client side
  if (import.meta.client) {
    document.documentElement.setAttribute('lang', lang)
  }
}
